import React, { useEffect } from "react";
import BomListingHeader from './BomListing/BomListingHeader/BomListingHeader';
import BomRematchListing from './BomListing/BomRematchListing';
import { useBOMStore } from "../../hooks/bom";
import System from "../../helper/system";


export function BomRematch() {
    const [{ bom_detail_by_bom_id }, { get_bom_detail_by_bom_id }] = useBOMStore();
    const bom_id = System.getParams().bomId;

    useEffect(() => {
        async function fetchHere() {
            if (bom_id) {
                await get_bom_detail_by_bom_id({ bomId: bom_id })
            } else {
                window.history.back()
            }
        }

        fetchHere()
    }, []);
    useEffect(() => {
        if (bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id === null) {
            window.history.back()
        }
    }, [bom_detail_by_bom_id]);

    return (
        <>
            <div className="logged-screen">

                <div>

                    <div id="main" className="">

                        {/* BOM-file-listing page */}
                        <div className="bom-copy">

                            <BomListingHeader />

                            <BomRematchListing />

                        </div>

                    </div>
                </div>
            </div>


        </>
    );

}
